import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import classNames from "classnames";
import { styled } from "styled-components";

import {
  buttonColor,
  buttonColorHover,
  buttonSize,
  minimunSize,
  styledObject,
} from "./styled";

import "assets/styles/index.scss";

const ButtonStyled = styled(Button)(styledObject);

const AppButton = props => {
  const {
    className,
    onClick,
    label,
    size = "large", //"small" | "medium" | "large"
    color = "blueGrey", //"blue" | "blueDark" | "blueLighten" | "grey" | "blueGrey" | "black"
    disabled,
    loading,
    varient = "contained", //contained" | "outlined"
    buttonProps,
    type, // "default", "primary", "ghost", "dashed", "link", "text"
    htmlType, // "button", "submit", "reset"
    icon,
    style,
  } = props;

  const { t } = useTranslation();
  const isContainedButton = varient === "contained";

  return (
    <ButtonStyled
      className={classNames({
        [className]: !!className,
      })}
      onClick={onClick}
      $height={buttonSize[size]}
      $width={minimunSize[size]}
      $borderColor={buttonColor[color]}
      $backgroundColor={
        isContainedButton ? buttonColor[color] : buttonColor.white
      }
      $color={isContainedButton ? buttonColor.white : buttonColor[color]}
      $hoverBorderColor={buttonColorHover[color]}
      $hoverBackground={
        isContainedButton ? buttonColorHover[color] : buttonColor.white
      }
      $hoverColor={
        isContainedButton ? buttonColor.white : buttonColorHover[color]
      }
      $isContainedButton={isContainedButton}
      loading={loading ? loading : ""}
      disabled={disabled}
      {...buttonProps}
      type={type}
      htmlType={htmlType}
      style={style}
      icon={icon ? icon : null}
    >
      {t(label)}
    </ButtonStyled>
  );
};

export default AppButton;
